import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";

const layoutPendingSaveModalProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({
        continue: PropTypes.func.isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};

type LayoutPendingSaveModalProps = PropTypes.InferProps<typeof layoutPendingSaveModalProps>;

const LayoutPendingSaveModal: React.FC<LayoutPendingSaveModalProps> = ({
    modalProps,
    isOpen,
}: LayoutPendingSaveModalProps) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("LAYOUT_PENDING_SAVE"));

    const continueRequest = () => {
        modalProps.continue();
        hide();
    };

    return (
        <MaterialModal
            title="Layout Pending Save"
            isOpen={isOpen}
            onClose={() => hide()}
            id="layout-pending-save"
            maxWidth="sm"
            primaryButtonText="Continue"
            onPrimaryButtonRequest={() => continueRequest()}
        >
            <div>
                The selected flow control layout has unsaved changes, if you continue, the changes will be lost. Are you
                sure you want to continue?
            </div>
        </MaterialModal>
    );
};

export default withModal(LayoutPendingSaveModal, "LAYOUT_PENDING_SAVE");
